// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dashboard-guest-status-icon {\n    width: 24px;\n    height: 23px;\n    margin-right: 0.5rem;\n}\n", ""]);
// Exports
module.exports = exports;
